export default {
    root: '/',
    calculator: '/calculator',
    calculatorProduct: '/calculator/:id',
    calculatorCar: '/calculator/car',
    calculatorCarElectric: '/calculator/car-electric',
    calculatorCarNoInsurance: '/calculator/car-no-insurance',
    calculatorMC: '/calculator/mc',
    calculatorATV: '/calculator/atv',
    calculatorSnowmobile: '/calculator/snowmobile',
    calculatorCampingCar: '/calculator/camping',
    calculatorCampingCaravan: '/calculator/caravan',
    calculatorBoat: '/calculator/boat',
    application: '/application/form',
    applicationReceipt: '/application/receipt',
    completion: '/completion',
    completionReceipt: '/completion/receipt',
    loanUpgrade: '/upgrade/:appId',
    loanUpgradeSuccess: '/upgrade-success/:appId',
};
